// src/config/roleAccessConfig.js
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import DashboardIcon from "@mui/icons-material/SpaceDashboard";
import SettingsIcon from "@mui/icons-material/Settings";

export const accessMatrix = {
  ADMIN: {
    'Admin Dashboard': 1,
    Dashboard: 0,
    Settings: 1,
  },
  COACH: {
    'Admin Dashboard': 0,
    Dashboard: 1,
    Settings: 1,
  },

};

export const tabList = [
  { label: "Admin Dashboard", icon: <AdminPanelSettingsIcon sx={{ mr: 1 }} />, value: 0 },
  { label: "Dashboard", icon: <DashboardIcon sx={{ mr: 1 }} />, value: 1 },
  { label: "Settings", icon: <SettingsIcon sx={{ mr: 1 }} />, value: 2 },
];
